// extracted by mini-css-extract-plugin
export default {"label":"CustomEnvironment_label__xORpK","mainConatiner":"CustomEnvironment_mainConatiner__9KgEI","crossIcon":"CustomEnvironment_crossIcon__k9A11"};